import { Flex, Table, Tbody, Th, Thead, Tr, useColorModeValue } from "@chakra-ui/react";
import { OrderCategory } from "models/order_category";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";
import useProductOrder from "views/admin/order/product/hooks/useProductOrder";
import ItemTableRow from "./ItemTableRow";
interface IItemTable{
    index: number;
    item1: OrderCategory;
}

const ItemTable =({index, item1} : IItemTable)=>{
    const { unidades } = useMeasureUnit();
    const {produtos} = useProductOrder();
    
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

    return(
        <>
      <Table
        variant="striped"
        color="gray.500"
        mb="24px"
        mt="12px"
        key={`${index}`}
      >
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ITEM
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #DESCRICAO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #UNIDADE
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #QTD
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #VALOR UN
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #TOTAL
              </Flex>
            </Th>
{/* 
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OPÇÕES
              </Flex>
            </Th> */}
          </Tr>
        </Thead>
        <Tbody>
            {
                item1.OrcamentoItem.map((item2, index2) => (
                    <ItemTableRow
                        index={index}
                        index1={index2}
                        item1={item2}
                        produtos={produtos}
                        unidades={unidades}

                    />
                ))
            }
            
        </Tbody>
        </Table>
        </>
    )
}
export default ItemTable;